/* eslint-disable */

const countDigits = (str) => {
  return str.replace(/[^0-9]/g, '').length;
};

const countSpecialCharacters = (str) => {
  return str.replace(/(\w|\s|\d|\t|\r|\n)/g, '').length;
};

const countUppercase = (str) => {
  return str.replace(/[^A-Z]/g, '').length;
};

const countLowercase = (str) => {
  return str.replace(/[^a-z]/g, '').length;
};

const strengths = {
  0: 'Zeer zwak',
  1: 'Zwak',
  2: 'Gemiddeld',
  3: 'Sterk',
  4: 'Zeer sterk',
};

const PasswordStrength = {
  /**
   * @param {HTMLElement} node
   * @param {Object} props
   * @return {void}
   */
  create(node, props) {
    this.node = node;
    this.output = node.parentNode.querySelector('.js-password-strength-meter');

    if (!this.output) {
      return;
    }

    this.check = () => { this.outputStrength(this.getStrength()) };

    this.check();

    $(this.node).on('keyup', () => {
      this.check();
    });
  },

  /**
   * Return a strength score between 0 and 4
   *
   * @returns {number}
   */
  getStrength() {
    const val = this.node.value;
    const digits = countDigits(val);
    const specialCharacters = countSpecialCharacters(val);
    const uppercase = countUppercase(val);
    const lowercase = countLowercase(val);

    if (val.length < 6) {
      return 0;
    } else if (digits === 0 && specialCharacters === 0) {
      return 1;
    } else if (specialCharacters === 0) {
      return 2;
    } else if (uppercase < 2 || lowercase < 2) {
      return 3;
    }

    return 4;
  },

  outputStrength(strength) {
    this.output.textContent = strengths[strength];
    this.output.setAttribute('data-strength', strength);
  },
};

export default PasswordStrength;
